import { jsxs, jsx } from 'react/jsx-runtime';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import { ArrowLink } from './ArrowLink.js';
import { ProductPageDialogContent } from './ProductPageDialogContent.js';

const ProductPageDialogSuccess = ({ closeDialogText, redirectionText, redirectionUrl, handleClose, }) => {
    return (jsxs(ProductPageDialogContent, Object.assign({ showIcon: true, iconProps: {
            src: getImageAssetUrl('icon_success_tick.webp'),
            alt: 'success',
            style: { width: 124, height: 124 },
        }, title: "Success!", subtitle: "We sent a text message with a link to download Brandclub and access your rewards." }, { children: [closeDialogText && jsx(ArrowLink, { text: closeDialogText, onTextClick: handleClose }), redirectionText && redirectionUrl && (jsx(ArrowLink, { text: redirectionText, url: redirectionUrl, onTextClick: () => window.open(redirectionUrl, '_blank') }))] })));
};

export { ProductPageDialogSuccess };
//# sourceMappingURL=ProductPageDialogSuccess.js.map
